module.exports = __webpack_public_path__ + "static/media/latch.7dc3f3f2.svg";